import React, { Component } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

import SisModal from "store/sis/sisModal";

import "./cctv.scss";

class Cctv extends Component {
	render() {
		return (
			<div>
				<SisModal
					id={this.props.id}
					title="CCTV 정보"
					closeEvent={() => {
						ReactDOM.render("", $("#cctvVideo")[0]);
					}}
					draggable
					contents={
						<div className="cctvWrap">
							<div className="posWrap">
								<span className="jibunLabel">지번주소</span>
								<span className="cctvJibunValue">도청입구 사거리</span>
							</div>

							<div id="cctvVideo" className="contentsWrap"></div>
						</div>
					}
				/>
			</div>
		);
	}
}

export default Cctv;
